import tokens from "./trc20.json";
export default tokens;
//# sourceMappingURL=trc20.js.map